exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".phoneBottom[data-v-b5b4e39e]{width:100%;background-color:#fff;min-height:145px;cursor:pointer;padding-top:30px;-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports
